import React, { useState } from "react";
import { MessageType, NEW_BASE_URL } from "../../../../Constant";
import { newReconDownloadExcelAPI } from "../../../../services/APIutils";
import UploadExcelModal from "../../../../shared/components/fileupload/UploadExcelModal";
import { PageWrapper } from "../../../../shared/layout";
import { saveExcelBlob } from "../../../../shared/methods/sharedMethods";
import { Button } from "../../../../shared/widgets";
import "./BulkEditGrossContribution.css";

function BulkEditGrossContribution() {
  const [showUploadXlsxModal, setShowUploadXlsxModal] = useState(false);

  const newCreateFormAndSubmit = ({ uriProps = {}, url }) => {
    newReconDownloadExcelAPI(url, uriProps).then((res) => {
      let fileName = res.headers["content-disposition"]?.split("Filename=")[1];
      fileName = fileName?.replaceAll("\"", "");
      saveExcelBlob({ blob: res.data, fileName });
    });
  };

  const exportSampleBulkEditGrossContributionUploadSheet = () => {
    newCreateFormAndSubmit({ url: `${NEW_BASE_URL}/v1/collectionPage/sampleBulkEditGCSheet` });
  };
  const toggleUploadXlsxModal = (data) => {
    setShowUploadXlsxModal(data);
  };

  const displayUploadXlsxModal = () => (
    <UploadExcelModal
      showModal={showUploadXlsxModal}
      messageCallBack={(type) => {
        if (type === MessageType.SUCCESS || !(type && type === MessageType.ERROR)) {
          setShowUploadXlsxModal(false);
        }
      }}
      uploadType="grossContribution"
    />
  );

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header heading="Bulk Gross Contribution Edit" hideS>
          <div className="pull-right">
            <a
              className="sample-button"
              role="link"
              tabIndex="0"
              onKeyDown={() => { /* onKeyDown */ }}
              onClick={() => exportSampleBulkEditGrossContributionUploadSheet()}

            >
              Sample File
            </a>
            <Button
              onClick={() => toggleUploadXlsxModal(true)}
              buttonText="Upload"
            />
          </div>
        </PageWrapper.Header>
        {showUploadXlsxModal && displayUploadXlsxModal()}
        <PageWrapper.Body style={{ marginTop: "135px" }}>
          {/* <h3>GC ins</h3> */}
          <div className="BulkEditGCInstructions">
            <span className="Heading">Instructions for bulk editing the gross contribution: </span>
            <br />
            <span className="Body">
              <span className="PointNumeric">1. Please download sample file for reference.</span>
              <span className="PointNumeric">2. Add only those buses where you want to edit the Gross contribution.</span>
              <span className="PointNumeric">3. Add only that contract type which you want to edit.</span>
              <span className="PointAlphabetical">a. If One bus has both flat fee & Revenue share and if you want to edit only flat fee, please add FF only in Contract Type</span>
              <span className="PointAlphabetical">b. If default flat fee applied is Rs. 59 and we want to change it Rs. 0, then process as per below format.</span>
              <span className="PointAlphabetical">c. Format:</span>
              <span className="PointRoman">I. Bus Number - KA123XXXX</span>
              <span className="PointRoman">II. Date - 16/08/2022</span>
              <span className="PointRoman">III. Contract  Type - FF</span>
              <span className="PointRoman">IV. Amount - 0 (Final value which will be applied on the contract)</span>
              <span className="PointNumeric">4. Use the short codes as below in Contract Type</span>
              <span className="PointAlphabetical">a. Flat fee - FF</span>
              <span className="PointAlphabetical">b. Revenue share - RS</span>
              <span className="PointAlphabetical">c. Baseline - Baseline</span>
              <span className="PointAlphabetical">d. Business Guarantee - BG</span>
              <span className="PointNumeric">
                5. Date format as given -
                <span id="HighlightedDateText">DD/MM/YYYY e.g. 16/08/2022</span>
              </span>
              <span className="PointNumeric">6. Bus Number format should be as per GPS Dashboard</span>
              <span className="PointNumeric">7. No cells should be empty in the sheet. We will discard it if any cell is left empty.</span>
              <span className="PointNumeric">8. Update only 200 records at a time</span>
            </span>
          </div>
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

export default BulkEditGrossContribution;
